import { render, staticRenderFns } from "./ServicesPayment.vue?vue&type=template&id=1ef7d1c8"
import script from "./ServicesPayment.vue?vue&type=script&lang=js"
export * from "./ServicesPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports